/* eslint-disable no-unused-vars */
export enum Positions {
  START = 'start',
  MIDDLE = 'middle',
  END = 'end'
}
/* eslint-disable no-unused-vars */
